import React from 'react';
import { Subject } from 'rxjs';
export var TASK_MESSAGE_TYPE;
(function (TASK_MESSAGE_TYPE) {
    TASK_MESSAGE_TYPE["willExecute"] = "willExecute";
    TASK_MESSAGE_TYPE["didExecute"] = "didExecute";
    TASK_MESSAGE_TYPE["didFail"] = "didFail";
    TASK_MESSAGE_TYPE["willTerminate"] = "willTerminate";
    TASK_MESSAGE_TYPE["didTerminate"] = "didTerminate";
})(TASK_MESSAGE_TYPE || (TASK_MESSAGE_TYPE = {}));
var DefaultTaskDispatcher = /** @class */ (function () {
    function DefaultTaskDispatcher() {
        var _this = this;
        this.subject = new Subject();
        this.willExecute = function (input) {
            _this.subject.next({ type: TASK_MESSAGE_TYPE.willExecute, payload: input });
        };
        this.didExecute = function (input) {
            _this.subject.next({ type: TASK_MESSAGE_TYPE.didExecute, payload: input });
        };
        this.didFail = function (input) {
            _this.subject.next({ type: TASK_MESSAGE_TYPE.didFail, payload: input });
        };
        this.willTerminate = function (input) {
            _this.subject.next({ type: TASK_MESSAGE_TYPE.willTerminate, payload: input });
        };
        this.didTerminate = function (input) {
            _this.subject.next({ type: TASK_MESSAGE_TYPE.didTerminate, payload: input });
        };
    }
    DefaultTaskDispatcher.prototype.asObservable = function () {
        return this.subject.asObservable();
    };
    return DefaultTaskDispatcher;
}());
export { DefaultTaskDispatcher };
var appContextNoop = function () {
    throw new Error('AppContext error: you must provide AppContext');
};
if (!window.internalAppContext) {
    window.internalAppContext = React.createContext({
        getToken: appContextNoop,
        getApiRequest: appContextNoop,
        getLogger: appContextNoop,
        getErrorListener: appContextNoop,
        getErrorStream: appContextNoop,
        taskDispatcher: new DefaultTaskDispatcher()
    });
}
export var AppContext = window.internalAppContext;
//# sourceMappingURL=AppContext.js.map